import React, { useState, useEffect } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
import { useParams, useNavigate, useLocation } from "react-router-dom";

function MilionarioGame() {
  const { localeTag, tableId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [tickAudio] = useState(() => {
    const a = new Audio("/sounds/tick.mp3");
    a.volume = 0.3;
    return a;
  });

  const searchParams = new URLSearchParams(location.search);
  const tokenUrl = searchParams.get("token");

  // 🔊 SUONI
  const playSound = (src) => {
  try {
    const audio = new Audio(src);
    audio.volume = 0.5;

    const p = audio.play();

    if (p !== undefined) {
      p.catch(() => {});
    }
  } catch (e) {
    console.log("Audio iPhone bloccato");
  }
};

  // 🔄 STATE
  const [step, setStep] = useState("eta"); // eta | tipo | loading | ready | gioco
  const [eta, setEta] = useState(null);
  const [tipo, setTipo] = useState(null);

  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);

  const [domande, setDomande] = useState([]);
  const [loadingDomande, setLoadingDomande] = useState(false);

  const [timeLeft, setTimeLeft] = useState(20);
  const [used5050, setUsed5050] = useState(false);
  const [hiddenAnswers, setHiddenAnswers] = useState([]);

  // ⏳ TIMER
  useEffect(() => {
    if (step !== "gioco" || loadingDomande || !domande.length) return;

    if (selected !== null) return; // 🔥 blocca tutto dopo risposta

    if (timeLeft <= 0) {
      setSelected(-1);
      playSound("/sounds/wrong.mp3");
      return;
    }

    if (timeLeft <= 5) {
  try {
    tickAudio.pause();
    tickAudio.currentTime = 0;

    const p = tickAudio.play();

    if (p !== undefined) {
      p.catch(() => {});
    }
  } catch (e) {
    console.log("Tick audio iPhone");
  }
}

    const timer = setTimeout(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, step, selected, current]);

  const usa5050 = () => {
    if (used5050) return;

    const q = domande[current];

    const wrongIndexes = q.risposte
      .map((_, i) => i)
      .filter(i => i !== q.corretta);

    // scegli 2 risposte sbagliate da nascondere
    const shuffled = wrongIndexes.sort(() => 0.5 - Math.random());
    const daNascondere = shuffled.slice(0, 2);

    setHiddenAnswers(daNascondere);
    setUsed5050(true);
  };
  // 🤖 GENERAZIONE DOMANDE
  const generaDomande = async (tipoSelezionato) => {
    setLoadingDomande(true);

    try {
      const functionsUS = getFunctions(undefined, "us-central1");
      const generaQuiz = httpsCallable(functionsUS, "generaQuizAI");

      const res = await generaQuiz({
        tipo: tipoSelezionato,
        eta: eta
      });
      console.log("RISPOSTA FUNCTION:", res.data);
      if (res.data.domande?.length) {
        setDomande(res.data.domande);
      } else {
        throw new Error("Nessuna domanda");
      }
    } catch (e) {
      console.error("Fallback locale:", e);
      // fallback
      setDomande([
        {
          domanda: "Qual è la capitale della Francia?",
          risposte: ["Parigi", "Roma", "Madrid", "Berlino"],
          corretta: 0
        }
      ]);
    }
    setLoadingDomande(false);
  };

  // 🎴 CARD
  const Card = ({ icon, title, desc, onClick }) => (
    <div
      onClick={onClick}
      style={{
        ...card,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minHeight: "120px"
      }}
    >
      <div style={{ fontSize: "2rem" }}>{icon}</div>
      <h3 style={{ margin: 0 }}>{title}</h3>
      <p style={{ margin: 0, opacity: 0.6, fontSize: "0.85rem" }}>
        {desc}
      </p>
    </div>
  );

  // =========================
  // STEP 1
  // =========================
  if (step === "eta") {
    return (
      <div style={container}>
        <div style={{ marginBottom: "8px", fontSize: "2.5rem" }}>💰</div>
        <h2 style={{ fontSize: "1.8rem", fontWeight: 800, background: "linear-gradient(135deg, #f5d76e, #c8a84b)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", margin: "0 0 6px" }}>
          Milionario del menù
        </h2>
        <p style={subtitle}>Chi giocando?</p>

        <div style={grid}>
          <Card icon="👶" title="Bambino" desc="Facile" onClick={() => { setEta("bambino"); setStep("tipo"); }} />
          <Card icon="🧑" title="Ragazzo" desc="Medio" onClick={() => { setEta("ragazzo"); setStep("tipo"); }} />
          <Card icon="👨" title="Adulto" desc="Difficile" onClick={() => { setEta("adulto"); setStep("tipo"); }} />
        </div>
        <button
          style={{
            marginTop: "20px",
            padding: "12px 24px",
            borderRadius: "12px",
            border: "none",
            background: "#e53935",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer",
            width: "100%",
            maxWidth: "320px"
          }}
          onClick={() =>
            navigate(`/giochi/${localeTag}/${tableId}?token=${tokenUrl}`)
          }
        >
          ← Torna ai giochi
        </button>
      </div>
    );
  }

  // =========================
  // STEP 2
  // =========================
  if (step === "tipo") {
    return (
      <div style={container}>
        <div style={{ marginBottom: "8px", fontSize: "2rem" }}>🎯</div>
        <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(135deg, #f5d76e, #c8a84b)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", margin: "0 0 6px" }}>
          Scegli il tipo
        </h2>
        <p style={subtitle}>Livello: <strong style={{ color: "#f5d76e" }}>{eta}</strong></p>

        <div style={grid}>
          <Card icon="🍽" title="Menù" desc="Domande sul locale"
            onClick={async () => {
              setTipo("menu");
              setStep("loading");

              setLoadingDomande(true);

              // piccolo delay per far vedere il loading subito
              await new Promise(res => setTimeout(res, 50));


              await generaDomande("menu");
              setStep("ready");

              setCurrent(0);
              setSelected(null);
              setTimeLeft(20);
            }}
          />

          <Card icon="🌍" title="Generale" desc="Cultura generale"
            onClick={async () => {
              setTipo("generale");
              setStep("loading");

              setLoadingDomande(true);

              // piccolo delay per far vedere il loading subito
              await new Promise(res => setTimeout(res, 50));


              await generaDomande("generale");
              setStep("ready");

              setCurrent(0);
              setSelected(null);
              setTimeLeft(20);
            }}
          />
        </div>
      </div>
    );
  }

  // =========================

  // STEP LOADING
  if (step === "loading") {
    return (
      <div style={container}>
        <div style={{ fontSize: "2rem", marginBottom: "10px" }}>🤖</div>
        <h2 style={{ margin: 0 }}>Sto creando le domande...</h2>
        <p style={{ opacity: 0.6 }}>Attendi qualche secondo</p>
      </div>
    );
  }

  // STEP READY
  if (step === "ready") {
    return (
      <div style={container}>
        <div style={{ fontSize: "2.5rem", marginBottom: "10px" }}>🚀</div>
        <h2 style={{ margin: 0 }}>Sei pronto?</h2>
        <p style={{ opacity: 0.6, marginBottom: "20px" }}>
          Hai 20 secondi per ogni domanda
        </p>

        <button
          style={menuBtn}
          onClick={() => {
            setTimeLeft(20);
            setCurrent(0);
            setSelected(null);
            setHiddenAnswers([]);
            setUsed5050(false);
            setStep("gioco");
          }}
        >
          ▶️ Inizia a giocare
        </button>
      </div>
    );
  }

  // STEP 3 GIOCO
  // =========================
  if (step === "gioco") {


    if (!domande.length) {
      return <div style={container}>⚠️ Nessuna domanda</div>;
    }

    const q = domande[current];

    return (
      <div style={container}>
        {/* Header domanda */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: "420px", marginBottom: "4px" }}>
          <span style={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)", fontWeight: 600, letterSpacing: "0.05em" }}>
            LIVELLO {current + 1} / 10
          </span>
          {/* Timer circolare */}
          <div style={{
            width: "48px", height: "48px", borderRadius: "50%",
            background: timeLeft <= 5
              ? "conic-gradient(#ff1744 0%, rgba(255,255,255,0.08) 0%)"
              : "conic-gradient(#f5d76e 0%, rgba(255,255,255,0.08) 0%)",
            border: `3px solid ${timeLeft <= 5 ? "#ff1744" : "#c8a84b"}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontWeight: 800, fontSize: "1rem",
            color: timeLeft <= 5 ? "#ff1744" : "#f5d76e",
            boxShadow: timeLeft <= 5 ? "0 0 12px rgba(255,23,68,0.5)" : "0 0 12px rgba(200,168,75,0.3)"
          }}>
            {timeLeft}
          </div>
        </div>


        <div style={questionBox}>
          {q.domanda}
        </div>

        <div style={{ marginBottom: "12px" }}>
          <button
            onClick={usa5050}
            disabled={used5050}
            style={{
              padding: "8px 16px",
              borderRadius: "50px",
              border: "1px solid rgba(255,255,255,0.2)",
              background: used5050
                ? "rgba(255,255,255,0.1)"
                : "linear-gradient(135deg, #f5d76e, #c8a84b)",
              color: used5050 ? "#888" : "#000",
              cursor: used5050 ? "not-allowed" : "pointer",
              fontWeight: "700",
              fontSize: "0.85rem"
            }}
          >
            🧠 50:50
          </button>
        </div>

        <div style={grid}>
          {q.risposte.map((r, i) => {
            if (hiddenAnswers.includes(i)) return null;
            const lettere = ["A", "B", "C", "D"];
            const isCorrect = i === q.corretta;
            const isSelected = selected === i;

            return (
  <button
    key={i}
    type="button"
    onClick={() => {
      if (selected !== null) return;

      playSound("/sounds/click.mp3");
      setSelected(i);

      setTimeout(() => {
        playSound(
          isCorrect
            ? "/sounds/correct.mp3"
            : "/sounds/wrong.mp3"
        );
      }, 300);
    }}
    style={{
      ...card,

      appearance: "none",
      WebkitAppearance: "none",
      outline: "none",

      width: "100%",
      cursor: "pointer",

      padding: "14px 16px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      textAlign: "left",

      border: isSelected
        ? isCorrect
          ? "2px solid #00e676"
          : "2px solid #ff1744"
        : "2px solid #4a6fa8",

      background: isSelected
        ? isCorrect
          ? "linear-gradient(180deg, #1a5c35 0%, #0d3320 100%)"
          : "linear-gradient(180deg, #5c1a1a 0%, #330d0d 100%)"
        : "linear-gradient(180deg, #1a3a7a 0%, #0d1f4a 100%)",

      boxShadow: isSelected
        ? isCorrect
          ? "0 0 20px rgba(0,230,118,0.4)"
          : "0 0 20px rgba(255,23,68,0.4)"
        : "0 4px 20px rgba(0,0,0,0.5)"
    }}
  >
                <span style={{
                  minWidth: "28px", height: "28px", borderRadius: "50%",
                  background: isSelected
                    ? isCorrect ? "#00e676" : "#ff1744"
                    : "linear-gradient(135deg, #c8a84b, #8b6914)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 800, fontSize: "0.85rem", flexShrink: 0,
                  color: "#fff"
                }}>{lettere[i]}</span>
                <span style={{ fontSize: "0.92rem", lineHeight: 1.3 }}>{r}</span>
              </button>
            );
          })}
        </div>

        <button
          style={{
            marginTop: "12px",
            padding: "10px 20px",
            borderRadius: "50px",
            border: "1px solid rgba(255,255,255,0.15)",
            background: "rgba(255,255,255,0.05)",
            color: "rgba(255,255,255,0.6)",
            cursor: "pointer",
            fontSize: "0.85rem"
          }}
          onClick={() =>
            navigate(`/menu/${localeTag}/${tableId}?token=${tokenUrl}`)
          }
        >
          ← Torna ai giochi
        </button>

        {selected !== null && (
          <div style={{ marginTop: "20px" }}>
            <div style={{
              padding: "12px 20px",
              borderRadius: "14px",
              background: selected === q.corretta
                ? "rgba(0,230,118,0.12)"
                : "rgba(255,23,68,0.12)",
              border: `1px solid ${selected === q.corretta ? "#00e676" : "#ff1744"}`,
              marginBottom: "8px"
            }}>
              {selected === -1 ? (
                <p style={{ margin: 0, color: "#ff1744", fontWeight: 700, fontSize: "1.1rem" }}>⏰ Tempo scaduto!</p>
              ) : selected === q.corretta ? (
                <p style={{ margin: 0, color: "#00e676", fontWeight: 700, fontSize: "1.1rem" }}>✅ Risposta corretta!</p>
              ) : (
                <p style={{ margin: 0, color: "#ff1744", fontWeight: 700, fontSize: "1.1rem" }}>❌ Risposta sbagliata</p>
              )}
              {selected !== q.corretta && selected !== -1 && (
                <p style={{ margin: "6px 0 0", fontSize: "0.85rem", color: "rgba(255,255,255,0.6)" }}>
                  La risposta corretta era: <strong style={{ color: "#00e676" }}>{q.risposte[q.corretta]}</strong>
                </p>
              )}
            </div>

            <button
              style={menuBtn}
              onClick={() => {
  if (selected !== q.corretta) {
    setStep("eta");
    return;
  }

  const prossimo = current + 1;

  if (prossimo >= domande.length) {
    setStep("eta");
    return;
  }

  // 🔥 reset PRIMA
  setSelected(null);
  setHiddenAnswers([]);
  setUsed5050(false);

  // 🔥 piccolo delay anti Safari/iPhone
  setTimeout(() => {
    setCurrent(prossimo);
    setTimeLeft(20);
  }, 120);
}}
            >
              {selected !== q.corretta
                ? "💀 Hai perso"
                : current + 1 >= domande.length
                ? "🏁 Hai vinto!"
                : "➡️ Prossima domanda"}
            </button>
          </div>
        )}
      </div>
    );
  }

  return null;
}

// 🎨 STILI — tema "Chi vuol essere milionario"
const container = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "radial-gradient(ellipse at center, #0d1b4b 0%, #050c1f 60%, #000 100%)",
  color: "#fff",
  padding: "24px 16px",
  textAlign: "center",
  fontFamily: "'Segoe UI', sans-serif"
};

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "14px",
  maxWidth: "420px",
  width: "100%"
};

const card = {
  padding: "18px 12px",
  borderRadius: "50px",
  background: "linear-gradient(180deg, #1a3a7a 0%, #0d1f4a 100%)",
  border: "2px solid #4a6fa8",
  cursor: "pointer",
  textAlign: "center",
  transition: "all 0.2s ease",
  boxShadow: "0 4px 20px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1)"
};

const subtitle = {
  opacity: 0.6,
  fontSize: "0.95rem",
  letterSpacing: "0.04em"
};

const questionBox = {
  padding: "22px 24px",
  borderRadius: "16px",
  background: "linear-gradient(180deg, #1a3a7a 0%, #0d1f4a 100%)",
  border: "2px solid #4a90d9",
  margin: "20px 0",
  fontSize: "1.05rem",
  lineHeight: "1.5",
  maxWidth: "420px",
  width: "100%",
  boxShadow: "0 0 30px rgba(74,144,217,0.2)"
};

const menuBtn = {
  marginTop: "16px",
  padding: "13px 28px",
  borderRadius: "50px",
  border: "2px solid #c8a84b",
  background: "linear-gradient(180deg, #c8a84b 0%, #8b6914 100%)",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "700",
  fontSize: "0.95rem",
  letterSpacing: "0.03em",
  boxShadow: "0 4px 16px rgba(200,168,75,0.4)"
};

export default MilionarioGame;